import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ReportStateStyledT = {
  isReportOpened: boolean;
};

const reportHeaderHeight = 48;
const cardsBlockHeight = 368; /* 360px card + 8px margin-top */
const cardsClosedTranslateValue = -(reportHeaderHeight + cardsBlockHeight);

export const ScheduleTilesOuterWrapStyled = styled(FlexContainer)`
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 6px;
  gap: 0;
`;

export const RowLabelStyled = styled(Typography)`
  margin-bottom: 6px;
  font-weight: ${({ theme }): string => theme.fontWeight.semibold.toString()};
  align-self: flex-start;
`;

export const CardsRowStyled = styled(FlexContainer)`
  flex-wrap: nowrap;
  gap: 6px;
  width: 100%;
  margin-bottom: 12px;
  overflow-x: auto;
  & > div {
    width: 100%;
  }
`;

type SuggestedAdjustmentsRowStyledT = {
  isOpened: boolean;
};

const suggestedRowHeight = 130;
export const SuggestedAdjustmentsRowStyled = styled(FlexContainer)<SuggestedAdjustmentsRowStyledT>`
  flex-direction: column;
  width: 100%;
  max-height: ${({ isOpened }): string => (isOpened ? `${suggestedRowHeight}px` : '0')};
  overflow: hidden;
  transition: max-height 0.25s linear;
`;

export const CardsWrapStyled = styled(FlexContainer)<ReportStateStyledT>`
  flex-wrap: nowrap;
  gap: 6px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
  max-height: ${({ isReportOpened }): string => (isReportOpened ? '368px' : '0')};
  overflow: ${({ isReportOpened }): string => (isReportOpened ? 'visible' : 'hidden')};
  transform: ${({ isReportOpened }): string =>
    isReportOpened ? 'translateY(0)' : `translateY(${cardsClosedTranslateValue}px)`};
  z-index: 0;
  transition: max-height 0.25s linear, transform 0.3s linear;
  & + div {
    margin-top: 0;
  }
`;

type ScheduleTitleStyledT = { $compact?: boolean };

export const ScheduleTitleStyled = styled(Typography)<ScheduleTitleStyledT>`
  margin: ${({ $compact }): string => ($compact ? '0 0 6px 0' : '0 0 4px 0')};
  font-weight: ${({ theme }): string => theme.fontWeight.medium.toString()};
  flex-shrink: 0;
  text-align: ${({ $compact }): string => ($compact ? 'center' : 'left')};
  font-size: ${({ $compact, theme }): string => ($compact ? theme.fontSize.sm : 'inherit')};
  line-height: ${({ $compact }): string => ($compact ? '1.25' : 'inherit')};
  color: ${({ theme }): string => theme.colors.primary.variant11};
`;

type ScheduleCompactInnerStyledT = { $compact?: boolean };

/** Wrapper: when compact, fills card height with balanced spacing (no negative margin). */
export const ScheduleCompactInnerStyled = styled.div<ScheduleCompactInnerStyledT>`
  margin: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

type ScheduleTableWrapStyledT = { $compact?: boolean };

/** Table wrapper: fills remaining card height; scroll when compact if content overflows. */
export const ScheduleTableWrapStyled = styled.div<ScheduleTableWrapStyledT>`
  flex: 1;
  min-height: 0;
  min-width: 140px;
  overflow: auto;

  & .MuiTableCell-root {
    padding-left: ${({ $compact }): string => ($compact ? '6px' : '4px')};
    padding-right: ${({ $compact }): string => ($compact ? '6px' : '4px')};
    padding-top: ${({ $compact }): string => ($compact ? '4px' : '3px')};
    padding-bottom: ${({ $compact }): string => ($compact ? '4px' : '3px')};
    font-size: ${({ theme }): string => theme.fontSize.sm};
    border-bottom: none;
  }
  & .MuiTableHead .MuiTableCell-root {
    font-weight: ${({ theme }): string => theme.fontWeight.semibold.toString()};
    color: ${({ theme }): string => theme.colors.primary.variant9};
    font-size: ${({ theme }): string => theme.fontSize.xs};
  }
  & .MuiTableBody .MuiTableCell-root:nth-child(3),
  & .MuiTableHead .MuiTableCell-root:nth-child(3) {
    border-left: 1px solid ${({ theme }): string => theme.colors.primary.variant6};
    padding-left: ${({ $compact }): string => ($compact ? '4px' : '8px')};
  }
`;
